'use strict';
define(['xhr-promise', '../data/config/app', './util', './analytics'], function (XhrPromise, config, util, analytics) {

    return {

        initOverlay: function () {
            this.waysToPayOverlayLinks = document.querySelectorAll('.navfooter-stclinks[href="javascript:;"]');
            this.overlayPanel = document.querySelector('.navfooter-overlay');
            this.backgroundOverlayVeil = document.querySelector('.navfooter-background--overlay');
            this.overlayClose = document.querySelector('.navfooter-overlay--close');
            this.bodyEL = document.querySelector('body');
            this.htmlEL = document.querySelector('html');
            this.closeTabs = document.querySelectorAll('.navfooter-overlay-backtab');
            this.lazyloadDiv = document.querySelector('.navfooter-lazyload');
            this.openOverlay = this.openOverlay.bind(this);
            this.openOverlayKeyup = this.openOverlayKeyup.bind(this);
            this.loadOverlayData = this.loadOverlayData.bind(this);
            this.loadOverlayDom = this.loadOverlayDom.bind(this);
            this.closeOverlay = this.closeOverlay.bind(this);
            this.dontCloseOverlayKeyup = this.dontCloseOverlayKeyup.bind(this);
            this.closeOverlayEnter = this.closeOverlayEnter.bind(this);
            this.closeOverlayKeyup = this.closeOverlayKeyup.bind(this);
            for (var iterator = 0; iterator < this.waysToPayOverlayLinks.length; iterator++) {
                this.waysToPayOverlayLinks[iterator].addEventListener('click', this.openOverlay);
                this.waysToPayOverlayLinks[iterator].addEventListener('keyup', this.openOverlayKeyup);

                analytics.bind(this.waysToPayOverlayLinks[iterator], [{
                    functionName: 'analyticsFooterFlyout',
                    event: 'click',
                    data: this.waysToPayOverlayLinks[iterator].title
                }]);
            }
            this.overlayClose.addEventListener('click', this.closeOverlay);
            this.overlayClose.addEventListener('keyup', this.closeOverlayEnter);
            this.backgroundOverlayVeil.addEventListener('click', this.closeOverlay);
            this.overlayPanel.addEventListener('keyup', this.closeOverlayKeyup);
            this.closeTabs[0].addEventListener('keyup', this.dontCloseOverlayKeyup);
            this.closeTabs[1].addEventListener('keyup', this.dontCloseOverlayKeyup);
        },
        loadOverlayDom: function (overlayData) {
            if (this.id && !window[this.id]) {
                window[this.id] = overlayData;
                document.querySelector('.navfooter-lazyload').style.display = 'none';
            }
            var overlayDOM = document.querySelector('.navfooter-overlay--content');
            overlayDOM.innerHTML = overlayData;
        },

        loadOverlayData: function (callback) {
            var xhrp = new XhrPromise();

            xhrp.send({
                url: config.wcsBaseUrl + config.CMD.contentAPI + '?contentId=' + this.id + '&catalogId=' + config.catalogId + '&langId=' + config.langId + '&storeId=' + config.storeId,
                method: 'GET'
            })
                .then(function (response) {
                    if (response.status === 200) {
                        callback(response.responseText);
                    }
                })
                .catch(function () {
                    //Handle errors here
                    callback([]);
                });
        },

        openOverlay: function (event) {
            this.target = event.currentTarget;
            this.id = event.currentTarget.getAttribute('data-content-id');
            if (this.id && window[this.id]) {
                this.loadOverlayDom(window[this.id]);
            } else {
                this.lazyloadDiv.style.display = 'block';
                this.loadOverlayData(this.loadOverlayDom);
            }
            util.addClass(this.overlayPanel, 'navfooter-overlay--visible');
            this.overlayPanel.style.visibility = 'visible';
            this.backgroundOverlayVeil.style.visibility = 'visible';
            util.addClass(this.backgroundOverlayVeil, 'navfooter-background--overlay-visible');
            util.addClass(this.bodyEL, 'navfooter-prevent-scrolling');
            util.addClass(this.htmlEL, 'navfooter-prevent-scrolling');
            this.closeTabs[0].style.display = 'block';
            this.closeTabs[1].style.display = 'block';
            this.overlayPanel.focus();
        },

        openOverlayKeyup: function (event) {
            var keyPressed = event.key || event.keyCode;
            if (keyPressed === 'Enter' || keyPressed === 13) {
                this.openOverlay(event);
            }
        },

        closeOverlay: function (event) {
            util.removeClass(this.overlayPanel, 'navfooter-overlay--visible');
            util.removeClass(this.backgroundOverlayVeil, 'navfooter-background--overlay-visible');
            util.removeClass(this.bodyEL, 'navfooter-prevent-scrolling');
            util.removeClass(this.htmlEL, 'navfooter-prevent-scrolling');
            setTimeout(function () {
                this.overlayPanel.style.visibility = 'hidden';
                this.backgroundOverlayVeil.style.visibility = 'hidden';
                var overlayDOM = document.querySelector('.navfooter-overlay--content');
                overlayDOM.innerHTML = '';
            }.bind(this), 500);
            if (event.key && (event.key === 'Enter' || event.key === 'Escape')) {
                this.target.focus();
            }
            this.closeTabs[0].style.display = 'none';
            this.closeTabs[1].style.display = 'none';
        },

        closeOverlayKeyup: function (event) {
            var keyPressed = event.key || event.keyCode;
            if (keyPressed === 27 || keyPressed === 'Escape') {
                this.closeOverlay(event);
            }
        },

        closeOverlayEnter: function (event) {
            var keyPressed = event.key || event.keyCode;
            if (keyPressed === 'Enter' || keyPressed === 13) {
                this.closeOverlay(event);
            }
        },

        dontCloseOverlayKeyup: function () {
            this.overlayClose.focus();
        }
    };
});


/** WEBPACK FOOTER **
 ** ./src/mns-core-ui-footer/templates/footer/js/FooterOverlay.js
 **/